import { Component, OnInit } from '@angular/core';
import { InteractionService } from '../../service/interaction/interaction.service';
import { ChatService } from '../../service/chat-service';

@Component({
    selector: 'app-product-type',
    templateUrl: './product-type.component.html',
    styleUrl: './product-type.component.scss',
    standalone: false
})
export class ProductTypeComponent  implements OnInit{
  constructor(private intService: InteractionService,private chatservice:ChatService) { }
  
    ngOnInit(): void {
    // hide header and sidebar
    this.intService.hideComponentHandler({hideHeader: true, hideSidebar: true});
    }
}
